export class AppConstants {
  static readonly DEFAULT_PAGE_SIZE = 50;
  static readonly DEFAULT_PAGE_SIZE_OPTIONS = [5, 10, 15, 20, 25, 50, 100];
  static readonly DEFAULT_DEBOUNCE_TIME = 300;
}
